import { Blockchain } from "@rarible/api-client"
import { apeChain } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const apechainConfig: StaticEthereumBlockchainConfig = {
  name: apeChain.name,
  icon: "/images/blockchains/apechain.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://apechain-api.rarible.org",
  chainId: apeChain.id,
  blockchain: Blockchain.APECHAIN,
  chainName: apeChain.name,
  exchange: {
    v2: "0xc747f8bA0514D30322a5BD4056F8c6434448D3F5",
    wrapper: "0xC49dB032fB73eacf337C27831A1435BBDCF2B044",
  },
  blockExplorers: [
    {
      url: "https://apescan.io",
      icon: "/images/scanner.svg",
      adress: "https://apescan.io/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "apechain-node",
  transferProxies: {
    nft: "0xD5A357fb04e2E9e5231AF6098767F794eaaC4b5a",
    erc721Lazy: "0x8ED4D54A11AEaFf453918604fD0D5E88029A9183",
    erc20: "0x2bC93750cffaFA586f00939A76f5aaB362D2F442",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("APECHAIN:0x0000000000000000000000000000000000000000"),
    symbol: "APE",
    name: "ApeCoin",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("APECHAIN:0x48b62137edfa95a428d35c09e44256a739f6b557"),
    symbol: "WAPE",
    name: "Wrapped ApeCoin",
    decimals: 18,
  },
  addFundsLink: "https://rarible.com/apechain/swap",
  hasStabilityProtocol: true,
  viem: apeChain,
}

export const getApechainConfig = (): StaticEthereumBlockchainConfig =>
  apechainConfig
